import { render, staticRenderFns } from "./library-select.component.vue?vue&type=template&id=8bf0c070&scoped=true&"
import script from "./library-select.component.ts?vue&type=script&lang=ts&"
export * from "./library-select.component.ts?vue&type=script&lang=ts&"
import style0 from "./library-select.component.scss?vue&type=style&index=0&id=8bf0c070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf0c070",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VList,VListItem,VListItemTitle,VMenu,VSpacer})
